var moment = require('moment');

// Each preset:
//   key       - stable id ('last_7d' | ... | 'next_12m')
//   labelKey  - i18next key under the 'inspect' namespace
//   column    - which column the preset lives in ('past' | 'future')
//   compute   - returns { from: moment, to: moment }
//
// The 'all' state for each column is represented by the state value 'all'
// (not a preset entry). Each column renders an "All" button that sets its
// column's state to 'all'.

function startOfToday() {
  return moment().startOf('day');
}

var PRESETS = [
  {
    key: 'last_7d',
    labelKey: 'inspect:dateRangeLast7d',
    column: 'past',
    compute: function () { var t = startOfToday(); return { from: t.clone().subtract(7, 'days'), to: t.clone() }; },
  },
  {
    key: 'last_30d',
    labelKey: 'inspect:dateRangeLast30d',
    column: 'past',
    compute: function () { var t = startOfToday(); return { from: t.clone().subtract(30, 'days'), to: t.clone() }; },
  },
  {
    key: 'last_90d',
    labelKey: 'inspect:dateRangeLast90d',
    column: 'past',
    compute: function () { var t = startOfToday(); return { from: t.clone().subtract(90, 'days'), to: t.clone() }; },
  },
  {
    key: 'last_12m',
    labelKey: 'inspect:dateRangeLast12m',
    column: 'past',
    compute: function () { var t = startOfToday(); return { from: t.clone().subtract(12, 'months'), to: t.clone() }; },
  },
  {
    key: 'next_7d',
    labelKey: 'inspect:dateRangeNext7d',
    column: 'future',
    compute: function () { var t = startOfToday(); return { from: t.clone(), to: t.clone().add(7, 'days') }; },
  },
  {
    key: 'next_30d',
    labelKey: 'inspect:dateRangeNext30d',
    column: 'future',
    compute: function () { var t = startOfToday(); return { from: t.clone(), to: t.clone().add(30, 'days') }; },
  },
  {
    key: 'next_90d',
    labelKey: 'inspect:dateRangeNext90d',
    column: 'future',
    compute: function () { var t = startOfToday(); return { from: t.clone(), to: t.clone().add(90, 'days') }; },
  },
  {
    key: 'next_12m',
    labelKey: 'inspect:dateRangeNext12m',
    column: 'future',
    compute: function () { var t = startOfToday(); return { from: t.clone(), to: t.clone().add(12, 'months') }; },
  },
];

function findPreset(key) {
  for (var i = 0; i < PRESETS.length; i++) {
    if (PRESETS[i].key === key) return PRESETS[i];
  }
  return null;
}

function presetsForColumn(column) {
  var out = [];
  for (var i = 0; i < PRESETS.length; i++) {
    if (PRESETS[i].column === column) out.push(PRESETS[i]);
  }
  return out;
}

// Resolve the effective { from, to } range from two column-state keys
// (each is 'all' or a preset key). The window's START comes solely from the
// PAST column and its END solely from the FUTURE column, so an 'all' column
// leaves its side open (null) instead of borrowing the other column's bound.
// Rules:
//   - Past sets 'from' (its preset start); 'all' leaves 'from' null (open start)
//   - Future sets 'to' (its preset end); 'all' leaves 'to' null (open end)
//   - Both 'all' -> { null, null } (no filter)
function computeRangeFromColumns(past, future) {
  var from = null;
  var to = null;
  if (past && past !== 'all') {
    var p = findPreset(past);
    if (p) from = p.compute().from;
  }
  if (future && future !== 'all') {
    var f = findPreset(future);
    if (f) to = f.compute().to;
  }
  return { from: from, to: to };
}

module.exports = {
  PRESETS: PRESETS,
  findPreset: findPreset,
  presetsForColumn: presetsForColumn,
  computeRangeFromColumns: computeRangeFromColumns,
};
